module.exports = __webpack_public_path__ + "static/media/_slash.a7f08959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_slash.jpg
// module id = 68
// module chunks = 0